module.exports = __webpack_public_path__ + "img/Andrea-Pinto.c038ced1.jpeg";